import { FormItemProps } from "antd";
import React from "react";

export const renderExtra = (extra: FormItemProps["extra"]) => {
  if (extra === null || extra === undefined || extra === false) return undefined;
  if (typeof extra === "string" || typeof extra === "number") {
    return (
      <small style={{ color: "#000" }}>
        <b>{extra}</b>
      </small>
    );
  }
  return extra;
};
